import React, { useState } from 'react';
import css from './AccordionSection.module.css';

const AccordionSection = ({ heading, children, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className={css.root}>
      <button type="button" className={css.header} onClick={() => setOpen(o => !o)}>
        <span className={css.heading}>{heading}</span>
        <span className={css.chevron}>{open ? '▲' : '▼'}</span>
      </button>
      {open ? <div className={css.content}>{children}</div> : null}
    </div>
  );
};

export default AccordionSection;
